// import { hadleFilterStructureData } from "@/utils/category";
import GetProductsByCategoryIdData from "./GetProductsByCategoryIdData";

const GetProductsByCategoryId = async (params) => {
  const {
    title,
    categoryID,
    locale,
    amountOfData,
    dataStart,
    dataTo,
    handshake,
    region_id,
  } = params;

  console.log("DATA IN FUN 111111111", {
    title,
    categoryID,
    locale,
    amountOfData,
  });

  const fetchedProducts = await GetProductsByCategoryIdData({
    token: handshake,
    categoryID,
    amountOfData,
    region_id,
  });

  let products = fetchedProducts?.data?.products.slice(
    dataStart ? dataStart : 0,
    dataTo ? dataTo : amountOfData
  );

  return {
    products,
    locale,
    categoryID,
  };
};

export default GetProductsByCategoryId;
